<template>
  <div class="v-app pt-2 mt-2">
    <div class="content" v-if="!thanksPage">
      <div class="row mx-0 pb-2 mb-2">
        <div class="col-12">
          <div class="feedback-header">
            <p class="ml-0">Last Step! Please Fill Out Form Below:</p>
          </div>
        </div>
      </div>
      <div class="row mx-0 pb-2 mb-2" v-if="currentOption && currentOption.is_offer_reward">
        <div class="col-12">
          <div class="reward d-flex align-items-center justify-content-start">
            <img src="../assets/confetti.svg" class="icon" width="16" alt="" />
            <p class="title">
              This information is needed to deliver your reward.
            </p>
          </div>
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-12" v-for="(collectin, index) in fields" :key="index">
          <label class="text-capitalize"
            >{{ collectin.field_name ? collectin.field_name : collectin.field_placeholder }}
            <span v-if="collectin.field_required" style="vertical-align:super">
              <svg width="6" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.68 0.852L5.22 1.812L3.576 2.424L5.22 3.024L4.668 4.02L3.3 2.928L3.564 4.68H2.448L2.688 2.928L1.308 4.044L0.732 3.024L2.364 2.412L0.744 1.812L1.284 0.84L2.688 1.92L2.436 0.167999H3.564L3.3 1.92L4.68 0.852Z" fill="#56657F" />
              </svg>
            </span>
          </label>
          <input class="form-control" type="text" :placeholder="collectin.field_placeholder" v-model="fields[index].answer" />
          <p class="collection-field-error" v-if="collectin.error">{{ collectin.error }}</p>
        </div>
      </div>
      <div class="row mx-0 mt-2" v-if="parseInt(currentOption && currentOption.require_signature)">
        <div class="col-12">
          <div class="panel">
            <div class="terms">
              <div class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path
                      d="M17.562 9.2887L21.1778 10.6168L18.1707 18.8041C17.8894 19.5741 16.3633 21.9837 15.3006 22.4752L15.0427 23.1786C14.9771 23.3569 14.8082 23.4685 14.6291 23.4685C14.5784 23.4685 14.5278 23.4591 14.4771 23.4413C14.2492 23.3569 14.131 23.1045 14.2154 22.8748L14.4593 22.2098C13.92 21.1621 14.3224 18.1194 14.5587 17.476L17.562 9.2887ZM22.7948 0.625887C21.8006 0.261966 20.6366 1.01419 20.3036 1.92306L18.1257 7.85646L21.7405 9.18271L23.9156 3.25024C24.1895 2.50739 23.7909 0.990745 22.7948 0.625887ZM16.2527 8.98199C16.3539 9.01951 16.4581 9.03733 16.5594 9.03733C16.9177 9.03733 17.2544 8.81785 17.3866 8.46144L19.6846 2.26353C19.8543 1.80675 19.6208 1.29933 19.164 1.1305C18.7035 0.963545 18.1998 1.19428 18.03 1.65105L15.7321 7.84896C15.5623 8.30574 15.7959 8.81316 16.2527 8.98199ZM12.5534 20.604C12.3161 20.3798 12.0207 20.1003 11.5423 19.8874C11.1484 19.712 10.7648 19.7036 10.4843 19.697C10.4552 19.697 10.4215 19.6961 10.3877 19.6951C10.2123 19.2149 9.85684 18.9129 9.32315 18.7947C8.61688 18.6456 8.05318 18.9786 7.66206 19.2355C7.69677 19.0386 7.75398 18.8041 7.79619 18.6353C7.93125 18.0913 8.07007 17.5285 7.96689 17.0014C7.88529 16.5849 7.53356 16.2754 7.10962 16.2454C6.01692 16.1844 5.124 16.7725 4.33707 17.3043C3.51074 17.8624 2.9808 18.1954 2.45368 18.0068C1.81026 17.778 1.74554 16.0362 2.05506 14.4849C2.33175 13.0874 2.84668 10.4855 4.16636 9.3037C4.61094 8.90602 5.25437 8.4755 5.78337 8.68466C6.40522 8.92853 6.91921 9.95276 7.03364 11.173C7.08148 11.6879 7.53075 12.0659 8.05506 12.019C8.57093 11.9712 8.94985 11.5135 8.90108 10.9976C8.71537 9.00919 7.78306 7.45409 6.469 6.93728C5.68207 6.63151 4.43086 6.54898 2.91421 7.90617C1.26438 9.38343 0.654714 11.8887 0.212944 14.12C-0.0084093 15.2343 -0.547725 18.9317 1.82339 19.7749C3.26781 20.2898 4.44118 19.4954 5.38381 18.8594C5.55639 18.7431 5.72615 18.6287 5.89123 18.5265C5.7346 19.2065 5.63705 19.9343 6.04787 20.5477C6.66034 21.4688 7.52606 21.5691 8.6197 20.8488C8.66191 20.8216 8.71068 20.7897 8.75664 20.7578C8.85794 20.9698 9.03708 21.2033 9.36255 21.3628C9.75648 21.556 10.1504 21.5654 10.4374 21.5729C10.5603 21.5757 10.7282 21.5795 10.7788 21.602C10.9552 21.6798 11.0593 21.7755 11.2619 21.9668C11.4138 22.1103 11.5742 22.2595 11.7777 22.4133C11.9466 22.5399 12.1435 22.5999 12.3386 22.5999C12.6238 22.5999 12.9061 22.4696 13.0899 22.2248C13.4004 21.8102 13.316 21.2221 12.9014 20.9116C12.7654 20.8066 12.6575 20.7025 12.5534 20.604Z"
                      fill="#56657F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <p class="title">
                Sign below to accept the <span style="cursor: pointer;" data-toggle="modal" data-target="#terms-conditions-modal">Terms &amp; Conditions</span> and
                <span data-toggle="modal" data-target="#privacy-modal" style="cursor:pointer;">Privacy Policy</span>
              </p>
            </div>
            <VueSignaturePad id="signature" height="111px" ref="signaturePad" :options="{ penColor: '#000', onEnd }" />
            <p class="collection-field-error mt-1" v-if="signatureError">{{ signatureError }}</p>
            <div class="col-12 mb-2 mt-2 pr-0 erase-btn-wraper" v-if="eraseSignatureButtonShow">
              <button class="btn btn-hollow" @click="undo">
                <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.7667 4.23366C10.8 3.26699 9.47334 2.66699 8.00001 2.66699C5.05334 2.66699 2.67334 5.05366 2.67334 8.00033C2.67334 10.947 5.05334 13.3337 8.00001 13.3337C10.4867 13.3337 12.56 11.6337 13.1533 9.33366H11.7667C11.22 10.887 9.74001 12.0003 8.00001 12.0003C5.79334 12.0003 4.00001 10.207 4.00001 8.00033C4.00001 5.79366 5.79334 4.00033 8.00001 4.00033C9.10667 4.00033 10.0933 4.46033 10.8133 5.18699L8.66667 7.33366H13.3333V2.66699L11.7667 4.23366Z"
                  />
                </svg>
                Erase
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-0 mt-2" v-else>
        <div class="col-12">
          <div class="d-flex custom-checkbox">
            <div>
              <label class="container">
                <input type="checkbox" checked="checked" v-model="accept_terms_condtion" />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="custom-checkbox-text">I accept the <span class="terms-and-condition" data-toggle="modal" data-target="#terms-conditions-modal">Terms & Conditions</span> and <span class="terms-and-condition" data-toggle="modal" data-target="#privacy-modal">Privacy Policy</span></div>
          </div>
          <p class="collection-field-error mt-2" v-if="!accept_terms_condtion">You must accept the Terms and condition</p>
        </div>
      </div>
      <div class="row mt-3 mx-0">
        <div class="col-12 mb-2">
          <button class="btn btn-solid w-100" @click="submitCollection">
            <i class="fa fa-spinner fa-spin" v-if="loading"></i>
            <svg v-if="!loading" class="icon" width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.50003 16.1698L5.33003 11.9998L3.91003 13.4098L9.50003 18.9998L21.5 6.99984L20.09 5.58984L9.50003 16.1698Z" />
            </svg>
            Submit
          </button>
        </div>
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-center mt-3">
            <Branding></Branding>
          </div>
        </div>
      </div>
    </div>
    <!-- Thanks Page  -->
    <div v-if="thanksPage">
      <thanks-page-componet :already_take_reward="already_take_reward"></thanks-page-componet>
    </div>
    <!-- TERMS & CONDITIONS MODALS -->

    <div class="modal fade" id="terms-conditions-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered reward-modal">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#8997B1" />
              </svg>
            </button>
            <h5 class="modal-title">Terms and conditions</h5>
            <p class="modal-desc" v-if="response.settings.terms_and_conditions" v-html="response.settings.terms_and_conditions"></p>
            <!-- <a href="https://www.acme.com/reward-3824" class="link"
              >https://www.acme.com/reward-3824</a> -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="privacy-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered reward-modal">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#8997B1" />
              </svg>
            </button>
            <h5 class="modal-title">Privacy Policy</h5>
            <p class="modal-desc" v-if="response.settings.privacy_policy" v-html="response.settings.privacy_policy"></p>
            <!-- <a href="https://www.acme.com/reward-3824" class="link"
              >https://www.acme.com/reward-3824</a> -->
          </div>
        </div>
      </div>
    </div>

    <!-- END MODALS -->
  </div>
</template>
<script>
import Vue from "vue";
import ThanksPageComponet from "./ThanksPageComponet.vue";
import Branding from "./partials/branding.vue";

import axios from "axios";

// import vueSignature from "vue-signature"

export default {
  name: "OptionSubmit",
  components: {
    ThanksPageComponet,
    Branding,
    // vueSignature
  },
  data() {
    return {
      currentOption: "",
      colletionResults: [],
      thanksPage: false,
      accept_terms_condtion: true,
      fields: [],
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      user: {
        pixel_key: "",
        ip: "",
        location: "",
        agent: navigator.userAgent,
        current_page: encodeURIComponent(window.location.href),
      },
      signatureError: "",
      signature: null,
      eraseSignatureButtonShow: false,
      already_take_reward: false,
      loading: false,
    };
  },
  watch: {
    "$route.query.thanksPage": function(thanksPage) {
      this.thanksPage = thanksPage;
    },
  },
  created() {
    if (this.$route.params.thanksPage) {
      this.thanksPage = true;
    }
    this.response = this.$session.get("response");
    this.currentOption = this.$session.get("currentOption");
    this.user.ip = sessionStorage.getItem("user_ip");
    this.user.location = sessionStorage.getItem("user_location");
    if (this.$canary_load_url) {
      this.user.current_page = encodeURIComponent(this.$canary_load_url);
    } else {
      this.user.current_page = encodeURIComponent(window.location.href);
    }
    this.user.pixel_key = this.$session.get("pixelKey");
    this.updateCollectionFields();
  },
  methods: {
    save12() {
      // var _this = this;
      // var png = _this.$refs.signature.save();
      // var jpeg = _this.$refs.signature.save("image/jpeg");
      // var svg = _this.$refs.signature.save("image/svg+xml");
      // console.log(png);
      // console.log(jpeg);
      // console.log(svg);
    },
    onEnd() {
      this.eraseSignatureButtonShow = true;
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty === false) {
        console.log(isEmpty);
      } else {
        this.signature = data;
      }
    },
    undo() {
      this.$refs.signaturePad.clearSignature();
      this.eraseSignatureButtonShow = false;
    },
    send_tracking_data(params) {
      // console.log(params, this.$session.get('baseUrl'))
      let query = "?";
      query += Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let send = new Image();
      send.src = `${this.$session.get("baseUrl")}/pixel-track/${query}`;
    },
    reset() {
      this.$router.push({ name: "Home" });
    },
    submitCollection() {
      if (this.$fromAdminSide) {
        return;
      }
      let isEmpty = false;
      let signatureData = null;
      let validationsError = false;
      if (this.$refs.signaturePad) {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        signatureData = data;
        if (this.currentOption.require_signature && isEmpty) {
          this.signatureError = "Signature field is required!";
          validationsError = true;
        }
      }

      this.fields.forEach((element, index) => {
        if (element.field_required && element.answer == "") {
          this.fields[index]["error"] = "This field is required!";
          validationsError = true;
        } else {
          this.fields[index]["error"] = "";
          if (element.field_name == "email") {
            if (!this.$helpers.validateEmail(element.answer)) {
              this.fields[index]["error"] = "Kindly enter valid email!";
              validationsError = true;
            }
          }
        }
        Vue.set(this.fields, index, this.fields[index]);
      });

      if (!this.accept_terms_condtion) {
        validationsError = true;
      }

      if (!validationsError) {
        if (this.$refs.signaturePad && !isEmpty && signatureData) {
          this.signature = signatureData;
        }
        this.sendSubmitInformation();
      }
    },
    trackingData() {
      // this.send_tracking_data({
      //   ...this.user,
      //   notification_id: this.response.notification_id,
      //   type: "canary_feedback_question_tracking",
      //   subtype: "collection", //
      //   unique_uuid: this.$session.get("uuid"),
      //   collections: JSON.stringify(this.fields),
      //   signature: this.signature,
      // });
    },
    sendSubmitInformation() {
      this.loading = true;
      axios
        .post(`${this.$session.get("baseUrl")}pixel-track/`, {
          ...this.user,
          notification_id: this.response.notification_id,
          type: "canary_feedback_question_submit",
          subtype: "collection", //
          unique_uuid: this.$session.get("uuid"),
          collections: JSON.stringify(this.fields),
          signature: this.signature,
          option_id: this.currentOption.feedback_option_id,
        })
        .then((response) => {
          this.loading = false;
          if (response.data.already_take_reward) {
            this.already_take_reward = true;
          }
          this.thanksPage = true;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    moveToSelectedOption(option_unique_id, option_question_id) {
      if (option_unique_id && option_question_id) {
        this.$router.push({
          name: "QuestionView",
          params: {
            id: option_unique_id,
            qid: option_question_id,
          },
        });
      }
    },
    updateCollectionFields() {
      this.fields = [];
      if (this.currentOption && this.currentOption.is_reward_email) {
        let current_index = this.fields.length;
        this.fields[current_index] = {
          field_name: "email",
          field_placeholder: "Enter your email...",
          label: "Email Address",
          field_required: true,
        };
        this.fields[current_index].answer = "";
        this.fields[current_index].error = "";
      }
      if (this.currentOption && this.currentOption.collection_fields) {
        for (let i = 0; i < this.currentOption.collection_fields.length; i++) {
          let current_index = this.fields.length;
          this.fields[current_index] = this.currentOption.collection_fields[i];
          this.fields[current_index].answer = "";
          this.fields[current_index].error = "";
        }
      }
    },
  },

  mounted() {
    setTimeout(() => {
      this.$helpers.updateColorAccordingApi();
    }, 20);
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            this.feedback = this.$session.get("response");
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          } else if (event.data.option) {
            this.response = this.$session.get("response");
            if (this.response.options.length) {
              this.response.options.forEach((element) => {
                if (element.feedback_option_id == this.currentOption.feedback_option_id) {
                  this.currentOption = element;
                  this.updateCollectionFields();
                  this.$session.set("currentOption", this.currentOption);
                }
              });
            }
          }
        }
      },
      false
    );
  },
};
</script>
<style lang="scss">
.fa-spinner {
  margin-right: 8px;
}
.terms-and-condition {
  color: var(--accent-color);
  cursor: pointer;
}
.custom-checkbox-text {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  /* display: flex; */
  /* align-items: center; */
  letter-spacing: 0.01em;
  color: #8997b1;
  margin-left: 2px;
  // padding: 3px 0px;
}
.erase-btn-wraper {
  text-align: right;
}
.collection-field-error {
  text-align: left;
  /* width: 100%; */
  margin: 0;
  font-size: 12px;
  color: var(--accent-color);
  margin-bottom: 4px;
}
.btn-hollow {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #ff077b;
  border-color: #ff077b;
  height: 35px;
  padding: 0 25px;
  &:hover {
    color: #ff077b;
  }
  svg {
    fill: #ff077b;
  }
}
.btn-solid {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: var(--action-btn-color) !important;
  background: var(--accent-color);
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 0 25px;
  .icon {
    margin-right: 8px;
    fill: var(--action-btn-color);
  }
}
.v-app {
  max-width: 420px;
  width: 100%;
  margin: auto;
  background: var(--background-color);
  overflow: auto;
}
.feedback-header {
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--title-color);
    margin: 0;
    margin-left: 8px;
  }
}

.reward {
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 12px;

  .icon {
    width: 24px;
    margin-right: 10px;
  }

  .title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: #313c4e;
    margin-bottom: 0px;
  }
}

label {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: #56657f;
  text-align: left;
  display: block;
  margin-bottom: 4px;
}

.form-control {
  background: #ffffff;
  border: 1px solid #ebedf0;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 14px;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #4b506d;
  // text-transform: capitalize;
  height: 44px;
  margin-bottom: 8px;

  &::placeholder {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: #4b506d;
    opacity: 0.4;
    text-transform: capitalize;
  }
}

.panel {
  background: #ffffff;
  border-radius: 4px;
  padding: 17px 11px;

  .terms {
    display: flex;
    align-items: center;

    .icon {
      margin-right: 8px;
    }

    .title {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 11px;
      line-height: 16px;
      text-align: left;
      letter-spacing: 0.01em;
      color: #56657f;
      margin: 0;

      span {
        color: var(--accent-color);
      }
    }
  }
}
#signature {
  background: #f1f2f9;
  border: 2px solid #f1f2f9;
  border-radius: 5px;
  margin-top: 32px;
}

.back-btn {
  margin-bottom: 35px;
  .icon {
    margin-right: 8px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
    }
  }
}
.copyright {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 5px 11px;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 40px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
</style>
